

export class CredentialDTO {
  public User!: string;
  public Password!: string;
  public Ip!: string;
  public idCaptcha!: string;
}

export class User {
  public id!: number;
  public userName!: string;
  public idTypeCourt!: number;
  public token!: string;
  public court!: number;
  public nameCourt!: string;
  public TypeCourt!: string;
  public isAdmin!: boolean;
  public idAdmin!: number;
  public courtAux!: number;
  public nameCourtAux!: string;
  public OrganosAutorizados!: number;
  public active!: number;
  public bPermisoAdmin!: boolean;
  public bSuperAdmin!: boolean;
  public bPermisoNoFirma!: boolean;
  public iClasificacionOrganismo!: number;
  public idAutoEnrolamiento!: number;
  public cuentaConSupervision!: boolean;
  public OrganosSupervisados!: number;
  public bajoSupervision!: boolean;
}

export class ChangePassIniCommand {
  public IdUser!: number;
  public User!: string;
  public currentPassword!: string;
  public newPassword!: string;
  public sIP!: string;
}

export class RegistroMasivo {
  public IdTipoOrganismo!: number;
  public JsonCarga!: string;
}

export class ResponseRegMasivoDTO {
  public jsonRegistro!: string;
}

